import React from "react";
import _ from 'lodash';

function RadioInputComponent(props) {
  const { id, schema, uiSchema, label, onChange, required, disabled } = props;
  let options = _.has(uiSchema, 'ui:options') ? uiSchema['ui:options'] : {};
  let isInline = _.has(options, 'inline') ? options['inline'] : false;
  const name = `${id}_radio_${Math.random(100000)}`;

  return (
    <React.Fragment>
      <label className="form-label">{label}{required && '*'}</label>
      <div className="form-group">
        {
          schema.enum.map((value, i) => (
            <React.Fragment key={`radio-${i}`}>
              <div className={`form-check ${isInline ? 'form-check-inline' : ''}`}>
                <label className="form-check-label">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={name}
                    value={value}
                    onChange={(e) => onChange(e.target.value)} 
                    checked={(value === props.value)}
                    disabled={disabled}
                    />
                  {value}
                </label>
              </div>
            </React.Fragment>
          ))
        }
      </div>
    </React.Fragment>
  )
}

export default RadioInputComponent;